




























import { Component, Watch } from 'vue-property-decorator'
import Alert from '@/components/Shared/Alert.vue';
import { AuthModule } from '@/store/Auth/AuthModule';
import { InstitutionsModule } from '@/store/Settings/InstitutionsModule';
import SaascadaVue from '@/components/Shared/SaascadaVue';
import InstitutionState from '@/components/Settings/Institutions/InstitutionState.vue';
import PageNames from '@/router/PageNames';

@Component({ name: 'Institutions', components: { Alert, InstitutionState }, metaInfo: { title: 'Institutions' } })
export default class extends SaascadaVue {

    headers = [
        { text: this.$t('pageText.institutions.fields.name'), sortable: false, width: '40%' },
        { text: this.$t('pageText.institutions.fields.code'), sortable: false, width: '30%' },
        { text: this.$t('pageText.institutions.fields.state'), sortable: false, width: '30%' },
    ];
    institutionsPage = 1;

    async created() {
        // Check for page number in URL parameters
        const page = this.$route.query.page;
        if (page) {
            this.institutionsPage = +page;
        }
    }

    async beforeMount() {
        await AuthModule.getMe();
        await InstitutionsModule.getInstitutions(this.institutionId);
    }

    get institutionId() {
        return AuthModule.me.institution.id;
    }

    get institutions() {
        return InstitutionsModule.institutions;
    }

    get totalInstitutionsPages() {
        // Hardcoded for now until we can get institutions from the API
        return 1;
    }

    get loading() {
        return InstitutionsModule.loading;
    }

    get pageSize() {
        return InstitutionsModule.pageSize;
    }

    @Watch('institutionsPage')
    async onInstitutionsPageChanged() {
        // Update current page route with page number
        this.$router.push({ name: this.$route.name, query: { page: `${this.institutionsPage}` } });
    }

    async navigateToInstitution(id: string) {
        this.$router.push({ name: PageNames.Institution, params: { id: id }, query: { tab: "0" } });
    }

}
